import React, { memo } from 'react';
import { uniqueId } from 'underscore';
import { Input } from 'src/components/helpers/Input';

import style from './style.module.css';

const CriteriaRangeComponent = ({ buyer: root, label, name, onChange, disabled }) => {
  const id = uniqueId();
  const [highName, lowName] = ['High', 'Low'].map(post => `${name}${post}`);

  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <div className={style.range}>
        <Input
          className="input-sm"
          disabled={disabled}
          id={id}
          name={lowName}
          onChange={onChange}
          placeholder=""
          root={root}
          deep
        />
        <span className={style.dash}>-</span>
        <Input
          className="input-sm"
          disabled={disabled}
          name={highName}
          onChange={onChange}
          placeholder=""
          root={root}
          deep
        />
      </div>
    </div>
  );
};

/** Criteria range component. */
export const CriteriaRange = memo(CriteriaRangeComponent);
